import { render, staticRenderFns } from "./EventTable.vue?vue&type=template&id=1427d067&scoped=true&lang=pug"
import script from "./EventTable.vue?vue&type=script&lang=ts"
export * from "./EventTable.vue?vue&type=script&lang=ts"
import style0 from "./EventTable.vue?vue&type=style&index=0&id=1427d067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1427d067",
  null
  
)

export default component.exports